import { render, staticRenderFns } from "./ClientModal.vue?vue&type=template&id=64c38f6f&scoped=true"
import script from "./ClientModal.vue?vue&type=script&lang=js"
export * from "./ClientModal.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ClientModal.vue?vue&type=style&index=1&id=64c38f6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c38f6f",
  null
  
)

export default component.exports